"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _sortable = require("@dnd-kit/sortable");
var _manageItem = require("../utils/manageItem");
var _manageListOfItems = require("../utils/manageListOfItems");
var _excluded = ["id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function useGridImagePicker(_ref) {
  var listOfSrc = _ref.listOfSrc,
    maxSelectablePreferenceByUser = _ref.maxSelectablePreferenceByUser,
    maxSizeInMB = _ref.maxSizeInMB,
    minAspectRatio = _ref.minAspectRatio,
    maxAspectRatio = _ref.maxAspectRatio,
    onChange = _ref.onChange;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDraggingActive = _useState2[0],
    setIsDraggingActive = _useState2[1];
  var _useState3 = (0, _react.useState)(listOfSrc),
    _useState4 = _slicedToArray(_useState3, 2),
    initialUrlList = _useState4[0],
    setInitialUrlList = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    itemNewUrl = _useState6[0],
    setItemNewUrl = _useState6[1];
  var _useState7 = (0, _react.useState)(function () {
      return (0, _manageListOfItems.getItemsInitialState)(listOfSrc);
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    items = _useState8[0],
    setItems = _useState8[1];
  (0, _react.useEffect)(function () {
    setItemNewUrl((0, _manageListOfItems.getItemChanged)(initialUrlList, listOfSrc));
  }, [listOfSrc]);
  (0, _react.useEffect)(function () {
    if (!itemNewUrl) return;
    setItems(function (prevItems) {
      return (0, _manageListOfItems.getItemsWithNewUrl)(prevItems, itemNewUrl);
    });
    setInitialUrlList(listOfSrc);
    setItemNewUrl(null);
  }, [itemNewUrl]);
  var maxSelectable = Math.min(maxSelectablePreferenceByUser, items.filter(function (item) {
    return !item.sizeError && !item.aspectRatioError && !item.fetchError;
  }).length);
  var numberOfCheckedItems = items.filter(function (item) {
    return item.checked;
  }).length;
  var isMaxSelectableReached = numberOfCheckedItems >= maxSelectable;
  var itemsAreReady = items.every(function (item) {
    return !item.loading;
  });
  var config = {
    maxSizeInMB: maxSizeInMB,
    minAspectRatio: minAspectRatio,
    maxAspectRatio: maxAspectRatio,
    maxSelectable: maxSelectable
  };
  var status = {
    isDraggingActive: isDraggingActive,
    isMaxSelectableReached: isMaxSelectableReached,
    itemsAreReady: itemsAreReady,
    numberOfCheckedItems: numberOfCheckedItems
  };
  (0, _react.useEffect)(function () {
    if (!onChange) return;
    onChange(items);
  }, [items]);
  (0, _react.useEffect)(function () {
    if (!itemsAreReady) return;
    var updatedItems = (0, _manageListOfItems.fillCheckedItems)(items, maxSelectable);
    setItems(updatedItems);
  }, [itemsAreReady]);
  var handleClickItem = function handleClickItem(targetItem) {
    var isUnclickable = !(0, _manageItem.isItemClickable)(targetItem, isMaxSelectableReached, itemsAreReady);
    if (isUnclickable) return;
    var updatedItems = targetItem.checked ? (0, _manageListOfItems.getUpdatedItemsWithDecrement)(items, targetItem) : (0, _manageListOfItems.getUpdatedItemsWithIncrement)(items, targetItem);
    var refreshedItems = (0, _manageListOfItems.refreshItemsPosition)(updatedItems);
    setItems(refreshedItems);
  };
  var handleSelectAll = function handleSelectAll() {
    var newItems = (0, _manageListOfItems.getSelectAllItems)(items, maxSelectable);
    var refreshedItems = (0, _manageListOfItems.refreshItemsPosition)(newItems);
    setItems(refreshedItems);
  };
  var handleDeselectAll = function handleDeselectAll() {
    var newItems = (0, _manageListOfItems.getDeselectAllItems)(items);
    setItems(newItems);
  };
  var handleUpdateItem = function handleUpdateItem(_ref2) {
    var id = _ref2.id,
      restOfKeys = _objectWithoutProperties(_ref2, _excluded);
    setItems(function (prevItems) {
      return prevItems.map(function (item) {
        return item.id === id ? _objectSpread(_objectSpread({}, item), restOfKeys) : item;
      });
    });
  };
  var handleDragStart = function handleDragStart() {
    setIsDraggingActive(true);
  };
  var handleDragEnd = function handleDragEnd(_ref3) {
    var active = _ref3.active,
      over = _ref3.over;
    setIsDraggingActive(false);
    if (active.id === over.id) return;
    var oldIndex = items.findIndex(function (item) {
      return item.id === active.id;
    });
    var newIndex = items.findIndex(function (item) {
      return item.id === over.id;
    });
    var reorderedItems = (0, _sortable.arrayMove)(items, oldIndex, newIndex);
    var refreshedItems = (0, _manageListOfItems.refreshItemsPosition)(reorderedItems);
    setItems(refreshedItems);
  };
  return {
    attributes: {
      items: items,
      config: config,
      status: status
    },
    methods: {
      handleClickItem: handleClickItem,
      handleUpdateItem: handleUpdateItem,
      handleDeselectAll: handleDeselectAll,
      handleSelectAll: handleSelectAll,
      handleDragStart: handleDragStart,
      handleDragEnd: handleDragEnd
    }
  };
}
var _default = exports["default"] = useGridImagePicker;